'use strict';

var Hounisen = Hounisen || {};
Hounisen.businessAreaSelector = new function () {
    function init() {
        // Init functions
        sessionCookie();
    }

    function sessionCookie() {

        if (window.location.href.indexOf("laboratorieudstyr") > -1) {
            setCookie('selectedStore', 'Laboratorieudstyr', 365);
        } else if (window.location.href.indexOf("laegepraksis") > -1) {
            setCookie('selectedStore', 'Lægepraksis', 365);
        }

        $('.business-area-selector-moda__button--lab').click(function () {
            setCookie('selectedStore', 'Laboratorieudstyr', 365);
            if (window.location.href.indexOf("laboratorieudstyr") > -1) {
                $('#business-area-selector').modal('hide');
            } else {
                location.href = "/Laboratorieudstyr";
            }
        });

        $('#accept-modal-close').click(function () {
            setCookie('selectedStore', 'Lægepraksis', 365);
            if (window.location.href.indexOf("laegepraksis") > -1) {
                location.reload();
            } else {
                location.href = "/laegepraksis";
            }
        });

        $('.business-area__link.lab, .logo__link').click(function () {
            setCookie('selectedStore', 'Laboratorieudstyr', 365);
        });

        $('.business-area-selector-moda__button--practice').click(function () {
            setCookie('selectedStore', 'Lægepraksis', 365);
            if (window.location.href.indexOf("laegepraksis") > -1) {
                $('#business-area-selector').modal('hide');
            } else {
                location.href = "/laegepraksis";
            }
        });
    }

    return {
        init: init
    };
}();
